import styled from "styled-components";
import {Colors} from "../Styles/Colors";
import {SiCommodore} from "react-icons/si";
import {ComponentType} from "react";
import {IconBaseProps} from "react-icons";
import {MdOutlineMailOutline} from "react-icons/md";
import {ViewTypes} from "../Provider/useGlobalSettingsContextProvider";
import useGlobalSettings from "../Provider/useGlobalSettings";
import {BsPersonWheelchair, BsQrCode} from "react-icons/bs";
import {CgProfile} from "react-icons/cg";
import {useNavigate} from "react-router-dom";
import {FaTeamspeak} from "react-icons/fa";
import {IoPlanetOutline} from "react-icons/io5";
import {GiAlienBug, GiMining, GiSpaceShuttle} from "react-icons/gi";
import Races from "../Icons/races/unknown_human_icon.svg";
import useWebSocketServer from "../Provider/useWebSocketServer";
import {GrWorkshop} from "react-icons/gr";
import {PiNotepadBold} from "react-icons/pi";

const Styles = {
    Frame: styled.div`
        padding: 30px;
        display: flex;
        gap: 30px;
        flex-wrap: wrap;
    `,
    App: styled.div<{ $disabled?: boolean }>`
        width: 80px;
        height: 80px;
        border: 1px solid ${Colors.raw.terminal_light};
        border-radius: 10%;
        cursor: pointer;
        &:hover {
            background-color: rgba(255, 255, 255, 0.2);
        }
        opacity: ${ p => p.$disabled ? 0.2 : 1 };
        filter: drop-shadow(1px 1px 10px yellow);
        box-shadow:
            0 0 6px rgba(255, 255, 255, 0.8),
            0 0 16px rgba(255, 255, 255, 0.5);
    `,
    IconSvg: styled.img`
        width: 40px;
        height: 40px;
        padding-top: 10px;
        color: red;
        fill: red;
    `
}
const RaceIcon: ComponentType<IconBaseProps> = ({ className }) => (
    <img
        className={className}
        src="/icons/races/unknown_human_icon.svg"
        alt=""
    />
);

const App = ({ title, icon, target, path, notActive }
     :{ title: string, icon: ComponentType<IconBaseProps>, target: string, path: string, notActive?: boolean }) => {

    const { Actions } = useGlobalSettings();
    const navigate = useNavigate()

    const Icon = styled( icon )`
        width: 40px;
        height: 40px;
        padding-top: 10px;
    `

    const handles = {
        click: () => {
            if( notActive )
                return
            Actions.setViewTo( target )
            void navigate( path )
        },
    }

    return <Styles.App onClick={ handles.click } $disabled={ notActive }>
        <Icon />
        <div>{title}</div>
    </Styles.App>
}

export const Apps = () => {

    const { connected } = useWebSocketServer()
    const { user } = useGlobalSettings()

    return [
        { title: 'Profil', icon: CgProfile, target: ViewTypes.Profile, path: '/profile' },
        { title: 'Freunde', icon: BsPersonWheelchair, target: ViewTypes.Profile, path: '/friends' },
        { title: 'Mail', icon: MdOutlineMailOutline, target: ViewTypes.EMail, path: '/mail' },
        { title: 'Squad', icon: FaTeamspeak, target: ViewTypes.QRCode,
            disabled: ! ( connected && user?.name ),
            path: '/squad' },

        { title: 'Notizen', icon: PiNotepadBold, target: ViewTypes.EMail, disabled: true, path: '/mission' },

        { title: 'Mission', icon: SiCommodore, target: ViewTypes.EMail, disabled: true, path: '/mission' },
        { title: 'Werk', icon: GrWorkshop, target: ViewTypes.IndustrialJobs, path: '/industrial-jobs' },
        { title: 'Guide', icon: IoPlanetOutline, target: ViewTypes.VerseGuide, path: '/verse-guide' },
        { title: 'Schiffe', icon: GiSpaceShuttle, target: ViewTypes.Ships, path: '/ships' },
        { title: 'Erze', icon: GiMining, target: ViewTypes.VerseGuide, disabled: true, path: '/verse-guide' },
        { title: 'Völker', icon: GiAlienBug, target: ViewTypes.VerseGuide, disabled: true, path: '/verse-guide' },
        { title: 'Share', icon: BsQrCode, target: ViewTypes.QRCode, path: '/share' },
    ]
}

export const DashBoard = () => {

    return <Styles.Frame>{
        Apps().map( ( { title, icon, target, disabled, path } ) =>
            <App title={ title } icon={ icon as ComponentType<IconBaseProps> } target={ target } notActive={ disabled } path={ path } /> )
    }</Styles.Frame>
}